import { Avatar as ChakraAvatar } from "@chakra-ui/react"

export default function Avatar({ src, name, icon, ...props }){
    return(
    <ChakraAvatar.Root {...props}>
        <ChakraAvatar.Fallback name={name} children={icon} />
        <ChakraAvatar.Image src={src} />
    </ChakraAvatar.Root>
    )
}